import Axios  from "axios"

export const getCardsaux = () => async (dispatch) => {
    dispatch({
        type: 'CARDAUX_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/cardaux/getall/', {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )      
        if(status===200){            
            dispatch({
                type: 'CARDSAUX_GET_SUCCESS',
                payload: data.cardsaux
            }) 
        }

    } catch (error) {
        dispatch({
            type: 'CARDAUX_ERROR'           
        })         
    }
}

export const getCardauxDetail = (cardaux) => async (dispatch) => {
    dispatch({
        type: 'CARDAUX_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/cardaux/get/'+ cardaux, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){            
            dispatch({
                type: 'CARDAUX_GET_DETAIL_SUCCESS',
                payload: data.cardaux
            })             
        }

    } catch (error) {
        dispatch({
            type: 'CARDAUX_ERROR'           
        })         
    }
}

export const getCardsauxByOperator = (user) => async (dispatch) => {
    dispatch({
        type: 'CARDAUX_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/cardaux/getcardsauxbyoperator/'+ user, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){
            dispatch({
                type: 'CARDAUX_GET_BY_OPERATOR_SUCCESS',
                payload: data.cardsaux
            })             
        }

    } catch (error) {
        dispatch({
            type: 'CARDAUX_ERROR'           
        })         
    }
}

export const getCardsauxForOperator = (user) => async (dispatch) => {
    dispatch({
        type: 'CARDAUX_LOADING'
    })
    try {
        const {data,status} = await Axios.get(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/cardaux/getcardsauxforoperator/'+ user, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )            
        if(status===200){
            dispatch({
                type: 'CARDAUX_GET_FOR_OPERATOR_SUCCESS',
                payload: {cardsaux: data.cardsaux, cardsparent: data.cardsparent}
            })             
        }

    } catch (error) {
        dispatch({
            type: 'CARDAUX_ERROR'           
        })         
    }
}

export const addCardaux = (idCard, user, datein, dateout, plot, crop, labor, machinery, litres_gasoil, litres_engine_oil, litres_hydraulic_oil, litres_urea, litres_grease, products, product_extra) => async (dispatch) => {
            dispatch({
        type: 'CARDAUX_LOADING'
    })
    try {
        const {
            status
        } = await Axios.post(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/cardaux/register', {
                card: idCard,
                user: user,
                in: datein,
                out: dateout,
                plot: plot,
                crop: crop,
                labor: labor,
                machinery: machinery,
                litres_gasoil: litres_gasoil,
                litres_engine_oil: litres_engine_oil,
                litres_hydraulic_oil: litres_hydraulic_oil,
                litres_urea: litres_urea,
                litres_grease: litres_grease,
                products: products,
                product_extra: product_extra
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CARDAUX_ADD_SUCCESS'
            })
        }
    } catch (error) {
        dispatch({
            type: 'CARDAUX_FAIL'
        })
    }
}

export const editCardaux = (cardaux) => async (dispatch) => {
    dispatch({
        type: 'CARDAUX_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/cardaux/edit/' + cardaux._id, {
                card: cardaux.card,
                user: cardaux.user,
                in: cardaux.datein,
                out: cardaux.dateout,
                plot: cardaux.plot,
                crop: cardaux.crop,
                labor: cardaux.labor
            }, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'CARDAUX_EDIT_SUCCESS',
            payload: {
                card: cardaux.card,
                user: cardaux.user,
                in: cardaux.datein,
                out: cardaux.dateout,
                //campaign: cardaux.campaign,
                plot: cardaux.plot,
                crop: cardaux.crop,
                labor: cardaux.labor,
                machinery: cardaux.machinery,
                litres_gasoil: cardaux.litres_gasoil,
                litres_engine_oil: cardaux.litres_engine_oil,
                litres_hydraulic_oil: cardaux.litres_hydraulic_oil,
                litres_urea: cardaux.litres_urea,
                // litres_antifreeze: cardaux.litres_antifreeze,
                litres_grease: cardaux.litres_grease,
                products: cardaux.products,
                product_extra: cardaux.product_extra,
                irrigation: cardaux.irrigation,
                _id: cardaux._id
            }
        })
    } catch (error) {
        dispatch({
            type: 'CARDAUX_ERROR'
        })
    }
}

export const deniCardaux = (cardaux) => async (dispatch) => {
    dispatch({
        type: 'CARDAUX_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/cardaux/deni/' + cardaux, {}, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'CARDAUX_DENI_SUCCESS',
            payload: {
                state: 'denied'
            }
        })
    } catch (error) {
        dispatch({
            type: 'CARDAUX_ERROR'
        })
    }
}

export const acceptCardaux = (cardaux) => async (dispatch) => {
    dispatch({
        type: 'CARDAUX_LOADING'
    })
    try {
        await Axios.put(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/cardaux/accept/' + cardaux, {}, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        dispatch({
            type: 'CARDAUX_ACCEPT_SUCCESS',
            payload: {
                state: 'accept'
            }
        })
    } catch (error) {
        dispatch({
            type: 'CARDAUX_ERROR'
        })
    }
}

export const removeCardaux = (idCardaux) => async (dispatch) => {
    try {
        const {
            data,
            status
        } = await Axios.delete(
            process.env.REACT_APP_DB_ADDRESS + '/api/client/cardaux/remove/' + idCardaux, {
                headers: {
                    auth: sessionStorage.getItem('jwt')
                }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'CARDAUX_DELETE_SUCCESS',
                payload: {
                    idCardaux: idCardaux,
                    message: data.message,
                    count: data.count
                }
            })
        }else{
            dispatch({
                type: 'CARDAUX_DELETE_NOT_SUCCESS',
                payload: {
                    message: data.message,
                    count: data.count
                }
            })
        }
    } catch (error) {
        dispatch({
            type: 'CARDAUX_ERROR'
        })
    }
}